import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Orb from "./Orb";
import Amy from "../assets/images/amy-w-bg.png";
import Dre from "../assets/images/dre-w-bg.png";
import { useTranslation, Trans } from "react-i18next";

const skpBooks = ["skp-book-1.png", "skp-book-2.png", "skp-book-3.png"];

const IntroSiKembar = () => {
  const { t, i18n } = useTranslation();

  const logoPath = i18n.language === "id" ? "../assets/images/logo-kembar-pintar.svg" : "../assets/images/logo-twinkle-twins.png";

  return (
    <section className="py-5 section-si-kembar">
      <Container style={{ position: "relative" }}>
        <Orb color="rgb(158, 143, 197)" bottom="-20vh" right="-60vh" />
        <Row className="d-flex align-items-center text-center banner-face" style={{ marginBottom: "3rem" }}>
          <Col md={4} className="d-none d-md-block">
            <img src={Amy} alt="Amy" className="img-fluid" />
          </Col>
          <Col xs={12} md={4}>
            <img src={logoPath} alt="Logo" className="img-fluid" />
          </Col>
          <Col md={4} className="d-none d-md-block">
            <img src={Dre} alt="Dre" className="img-fluid" />
          </Col>
          <Col xs={6} className="d-block d-md-none">
            <img src={Amy} alt="Amy" className="img-fluid" />
          </Col>
          <Col xs={6} className="d-block d-md-none">
            <img src={Dre} alt="Dre" className="img-fluid" />
          </Col>
        </Row>
        <Row className="align-items-center jua" style={{ fontWeight: 400 }}>
          <Col lg={6}>
            <div className="section-title">
              <Trans
                i18nKey="intro-skb-title"
                components={{
                  br: <br />,
                }}
              />
            </div>
            <div className="subsection-title">
              <Trans
                i18nKey="intro-skb-desc"
                components={{
                  blue: <span className="color-blue" />,
                }}
              />
            </div>
          </Col>
          <Col lg={6} className="">
            <img src="../assets/images/book_skp_qibla.png" alt="Book SKP" className="img-fluid" />
          </Col>
        </Row>

        <Row className="intro-skb-books justify-content-center"> 
          {skpBooks.map((item, index) => (
            <Col key={index} sm={6} md={6} lg={4}  className="my-3">
              <img src={"../assets/images/" + item} alt="Book SKP" className="img-fluid" />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default IntroSiKembar;
